import React, { useEffect } from "react";
import { Form, Select, InputNumber, Typography } from "antd";

import { elvis } from "../../Utils";

const { Option } = Select;
const { Title } = Typography;

// Italian Civil Protection 0–5 damage scale (same as DamageChurchForm).
const DAMAGE_SCALES = [
    { value: "ABSENT",      label: "0 — Absent" },
    { value: "LOW",         label: "1 — Low" },
    { value: "MODERATE",    label: "2 — Moderate" },
    { value: "SEVERE",      label: "3 — Severe" },
    { value: "VERY_SEVERE", label: "4 — Very severe" },
    { value: "COLLAPSE",    label: "5 — Collapse" },
];

/**
 * Damage to an added block: an overall assessment (date, extension/level,
 * description), not distinguished between the block's structural elements.
 * Date and description live in the generic damage panel.
 */
const AddedBlockDamageForm = props => {
    const [form] = Form.useForm();
    const isEditMode = props.isEditMode || false;

    useEffect(() => {
        if (props.record.damage) {
            form.setFieldsValue({
                damageScale: props.record.damage.damageScale,
                extensionPercent: props.record.damage.extensionPercent,
            });
        }
    }, [props.record.damage, form]);

    const onFieldsChange = () => {
        if (!isEditMode) return;
        const values = form.getFieldsValue();
        const newDamage = { ...props.record };
        newDamage.damage.damageDiscriminator = "WHOLE_STRUCTURE";
        newDamage.damage.damageScale = elvis(values.damageScale);
        newDamage.damage.extensionPercent = elvis(values.extensionPercent);
        newDamage.valid = true;
        props.parentCallback(newDamage);
    };

    return (
        <Form
            form={form}
            layout="horizontal"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            className="details_form"
            name="addedBlockDamageForm"
            onFieldsChange={onFieldsChange}
        >
            <Title className="details_form_header"
                title="Damages details"
                subTitle="Added block"
            />
            <Form.Item label="Damage level" name="damageScale">
                <Select allowClear disabled={!isEditMode}>
                    {DAMAGE_SCALES.map(opt => (
                        <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item label="Total extension (%)" name="extensionPercent">
                <InputNumber min={0} max={100} disabled={!isEditMode} />
            </Form.Item>
        </Form>
    );
};

export default AddedBlockDamageForm;
